import type { CmsApiPage } from '#/modules/cms/api/types/CmsApiPage';

type Props = {
  content: CmsApiPage;
};

export function getIsContentFullWidthLayout({ content }: Props) {
  return content.layout === 'FULL_WIDTH';
}
